// src/lib/software.js
import api from "../api";

/* ================= SOFTWARE APIs ================= */

// ADMIN + EMPLOYEE
export const getSoftware = () => api.get("/software/my");

// ADMIN ONLY
export const renewSoftware = (id, data) =>
  api.post(`/software/renew/${id}`, data);

export const getSoftwareRenewalHistory = (id) =>
  api.get(`/software/renewal-history/${id}`);
